<template>
  <div class="login-page">
    <div class="login-bg"
         aria-hidden="true"></div>
    <div class="login-shell">

      <div class="login-card">
        <div class="login-header">
          <div class="login-title">欢迎登录</div>
          <p class="login-sub">请使用授权账号登录</p>
          <div class="title-line"></div>
        </div>

        <div class="login-form">
          <div class="input-item">
            <img src="../../static/image/zhanghao.png"
                 alt=""
                 class="input-icon" />
            <el-input placeholder="请输入账号"
                      v-model="info.tel"
                      class="login-input"
                      maxlength="11" />
          </div>
          <div class="input-item">
            <img src="../../static/image/mima.png"
                 alt=""
                 class="input-icon" />
            <el-input placeholder="请输入密码"
                      v-model="info.pwd"
                      type="password"
                      class="login-input"
                      show-password
                      @keyup.enter.native="login" />
          </div>

          <div class="checkbox-item"
               @click="changeRadio">
            <div class="checkbox"
                 :class="{ checked: radio }">
              <i class="el-icon-check"
                 v-if="radio"></i>
            </div>
            <span>阅读并同意</span>
            <span class="link"
                  @click.stop="getInfo('user_agreement')">《用户协议》</span>
            <span class="link"
                  @click.stop="getInfo('privacy')">《隐私政策》</span>
          </div>

          <el-button type="primary"
                     class="login-btn"
                     @click="login">登 录</el-button>
        </div>
        <div class="register-link">
          <span @click="register">没有账号？立即注册</span>
        </div>
        <div class="register-link">
          <span @click="goPwd">忘记密码</span>
        </div>
        <div class="login-footer-inner">
          <div class="company-name">千顷职汇人力资源有限公司</div>
        </div>
      </div>
    </div>

    <!-- <footer class="login-viewport-footer"
            @click="goXinfan">
      <img class="support-brand-img"
           src="../../static/image/login/xinfan.png"
           alt="新帆软件技术支持"
           title="新帆软件技术支持" />
    </footer> -->
  </div>
</template>

<script>
export default {
  name: 'LoginPage',
  components: {},
  data() {
    return {
      info: {
        tel: '',
        pwd: '',
      },
      radio: false,
      isDisabled: false,
      countdown: 0,
      intervalId: null,
    }
  },
  computed: {
    buttonText() {
      return this.isDisabled ? `${this.countdown}秒后重新获取` : '获取验证码'
    },
    /** 打包后走 public；若有正式 PNG 可放 public/static/image/login/xinfan-support.png 并改扩展名 */
    supportBrandSrc() {
      const base = (process.env.BASE_URL || '/').replace(/\/?$/, '/')
      return `${base}static/image/login/xinfan-support.svg`
    },
  },
  beforeMount() {
    console.log(this.$route.path, 'this.$route.path')
  },
  mounted() {},
  methods: {
    changeRadio() {
      this.radio = !this.radio
    },
    register() {
      this.$router.push('/register')
    },
    goPwd() {
      this.$router.push('/forgetPwd')
    },
    getInfo(type) {
      const targetRoute = this.$router.resolve({
        name: 'article',
        query: { type: type },
      })
      window.open(targetRoute.href, '_blank')
    },
    async getCaptcha() {
      if (this.isDisabled) return
      if (!this.info.tel) {
        this.$message.error('请先输入手机号')
        return
      }
      await this.$api.index.getVerify({ type: '2' }).then((res) => {
        this.info.key = res.data.key
        if (res.code == 200) {
          this.$api.index.sendSms(this.info).then((res) => {
            if (res.code == 200) {
              this.$message.success('验证码已发送')
            } else {
              this.$message.error(res.msg)
            }
          })
        } else {
          this.$message.error('请求失败请稍后重试')
        }
      })
      this.startCountdown()
    },
    startCountdown() {
      this.isDisabled = true
      this.countdown = 60
      this.intervalId = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown -= 1
        } else {
          clearInterval(this.intervalId)
          this.isDisabled = false
          this.countdown = 0
        }
      }, 1000)
    },
    goXinfan() {
      window.open('https://www.seenfine.com/', '_blank')
    },
    login() {
      if (!this.radio) {
        this.$message.warning('请先同意《用户协议》《隐私政策》')
        return
      }
      if (!this.info.tel) {
        this.$message.error('请输入账号')
        return
      }
      if (!this.info.pwd) {
        this.$message.error('请输入密码')
        return
      }
      this.$api.index.login(this.info).then((res) => {
        if (res.code == 200) {
          this.$message.success('登录成功')
          if (res.data.token) {
            localStorage.setItem('token', res.data.token)
            localStorage.setItem('userName', res.data.name)
            localStorage.setItem('userPic', res.data.pic)
            this.$router.push('/homePage')
            this.$router.go(0)
          }
        } else {
          this.$message.error(res.msg)
        }
      })
    },
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId)
    }
  },
}
</script>

<style scoped lang="scss">
/* 与 PC 前台一致：上浅蓝 → 下白，轻装饰、无重色遮罩 */
.login-page {
  min-height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  background: linear-gradient(
    180deg,
    #d6ecff 0%,
    #eef6ff 38%,
    #f8fbff 72%,
    #ffffff 100%
  );
}

.login-bg {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background-image: radial-gradient(
      ellipse 120% 80% at 50% -15%,
      rgba(59, 130, 246, 0.12) 0%,
      transparent 52%
    ),
    radial-gradient(
      ellipse 70% 45% at 100% 100%,
      rgba(14, 165, 233, 0.08) 0%,
      transparent 48%
    ),
    linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.82) 0%,
      rgba(255, 255, 255, 0.35) 42%,
      rgba(255, 255, 255, 0) 100%
    ),
    url('~@/static/image/login/background.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.login-shell {
  position: relative;
  z-index: 1;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: clamp(24px, 6vw, 80px);
  padding: 48px 24px 120px;
  flex-wrap: wrap;
}

.login-brand {
  max-width: 420px;
  color: #1e293b;
}

.brand-wordmark {
  font-size: clamp(28px, 3.2vw, 36px);
  font-weight: 800;
  letter-spacing: 0.04em;
  color: #0f172a;
  margin-bottom: 8px;
}

.brand-tagline {
  margin: 0 0 10px;
  font-size: 16px;
  font-weight: 600;
  color: #334155;
}

.brand-desc {
  margin: 0;
  font-size: 14px;
  color: #64748b;
  line-height: 1.65;
}

.login-card {
  width: 100%;
  max-width: 440px;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #e8eef5;
  box-shadow: 0 12px 40px rgba(15, 23, 42, 0.08),
    0 2px 8px rgba(15, 23, 42, 0.04);
  padding: 0 0 28px;
  box-sizing: border-box;
}

.login-header {
  text-align: center;
  padding: 40px 32px 8px;
}

.login-title {
  font-size: 26px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: 0.02em;
}

.login-sub {
  margin: 10px 0 0;
  font-size: 14px;
  color: #64748b;
}

.title-line {
  width: 48px;
  height: 3px;
  border-radius: 2px;
  background: linear-gradient(90deg, #3b82f6, #0ea5e9);
  margin: 18px auto 0;
}

.login-form {
  padding: 8px 36px 0;
  display: flex;
  flex-direction: column;
}

.input-item {
  display: flex;
  align-items: center;
  background: #f8fafc;
  border: 1px solid #e8eef5;
  border-radius: 10px;
  width: 100%;
  max-width: 368px;
  margin: 0 auto 16px;
  padding: 4px 14px;
  box-sizing: border-box;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.input-item:focus-within {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
  background: #fff;
}

.input-icon {
  width: 22px;
  height: 22px;
  margin-right: 10px;
  flex-shrink: 0;
}

::v-deep .login-input .el-input__inner {
  border: none;
  outline: none;
  box-shadow: none;
  background: transparent;
  height: 46px;
  line-height: 46px;
  font-size: 15px;
  color: #0f172a;
}

::v-deep .login-input .el-input__inner::placeholder {
  color: #94a3b8;
}

.checkbox-item {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-size: 13px;
  color: #64748b;
  margin: 8px auto 20px;
  max-width: 368px;
  width: 100%;
  cursor: pointer;
  user-select: none;
  gap: 2px 0;
}

.checkbox {
  width: 18px;
  height: 18px;
  border: 2px solid #cbd5e1;
  border-radius: 4px;
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #fff;
  background: #fff;
  flex-shrink: 0;
  transition: all 0.2s;
}

.checkbox.checked {
  background: linear-gradient(145deg, #3b82f6, #0ea5e9);
  border-color: transparent;
}

.checkbox-item .link {
  color: #2563eb;
  margin: 0 4px;
  font-weight: 500;
}

.checkbox-item .link:hover {
  text-decoration: underline;
}

.login-btn {
  width: 100%;
  max-width: 368px;
  height: 48px;
  margin: 0 auto;
  border: none;
  border-radius: 999px;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0.35em;
  padding-left: 0.35em;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  box-shadow: 0 8px 24px rgba(37, 99, 235, 0.28);
}

::v-deep .login-btn:hover,
::v-deep .login-btn:focus {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
}

.register-link {
  color: #2563eb;
  text-align: center;
  padding: 12px 0;
  cursor: pointer;
  font-weight: 500;
}

.login-footer-inner {
  text-align: center;
  padding: 20px 32px 0;
  //   border-top: 1px solid #e2e8f0;
  margin-top: 8px;
}

.company-name {
  font-size: 13px;
  color: #94a3b8;
  line-height: 1.6;
}

.login-viewport-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  gap: 8px;
  padding: 12px 16px 16px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.92) 40%,
    #ffffff 100%
  );
  border-top: 1px solid rgba(226, 232, 240, 0.9);
}

.support-brand-img {
  height: 16px;
  //   width: 120px;
  object-fit: contain;
}

/* PC：整行占满宽度，品牌靠左、登录框靠右（不再整体居中） */
@media (min-width: 901px) {
  .login-shell {
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
    box-sizing: border-box;
    justify-content: flex-end;
    align-items: center;
    flex-wrap: nowrap;
    gap: clamp(20px, 3vw, 48px);
    padding: 48px clamp(24px, 4vw, 56px) 120px;
  }

  .login-brand {
    flex: 0 1 auto;
    min-width: 0;
  }

  .login-card {
    flex: 0 0 auto;
    margin-left: 0;
    width: 100%;
    max-width: 440px;
  }
}

@media (max-width: 900px) {
  .login-brand {
    text-align: center;
    width: 100%;
  }
}
</style>
